<script lang="ts">
  import ExtraAppleCareService from './PDPExtraServices/ExtraAppleCareService.svelte';
  import ExtraCareService from './PDPExtraServices/ExtraCareService.svelte';
  import ExtraCoatingService from './PDPExtraServices/ExtraCoatingService.svelte';
  import PdpExtraSetupService from './PDPExtraSetupService.svelte';
  import PdpOtherService from './PDPOtherService.svelte';
  import PdpSafeguardService from './PDPSafeguardService.svelte';
  import PdpSectionCard from './PDPSectionCard.svelte';
  import PdpSplitAcService from './PDPSplitACService.svelte';

  export let data: any = null;
  export let eligibleVasEntries: any = null;
  export let serviceType = '';
  const appleCareTitleDetails =
    serviceType === 'appleCare' ? getLabelDataByCode(data?.servicesBlocks, 'servicesAppleCarePDPContent') : null;
  function getComponentData(vasEntry, servicesBlocks) {
    const componentData = {
      component: null,
      labelData: null,
      componentData: vasEntry,
      lmdConfigurations: data?.lmdConfigurations,
    };
    if (vasEntry?.extraSetupService) {
      componentData.component = PdpExtraSetupService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'extraServicesSetupPDPContent');
    } else if (vasEntry?.splitAcService) {
      componentData.component = PdpSplitAcService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'servicesSetupPDPContent');
    } else if (vasEntry?.appleCareService) {
      componentData.component = PdpOtherService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'servicesAppleCarePDPContent');
      // this variable is used for other purpose, not for lmdConfigurations
      componentData.lmdConfigurations = ExtraAppleCareService;
    } else if (vasEntry?.extraCareCoating) {
      componentData.component = PdpOtherService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'servicesExtraCareCoatingPDPContent');
      // this variable is used for other purpose, not for lmdConfigurations
      componentData.lmdConfigurations = ExtraCoatingService;
    } else if (vasEntry?.extraCareService) {
      componentData.component = PdpOtherService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'servicesExtraCarePDPContent');
      // this variable is used for other purpose, not for lmdConfigurations
      componentData.lmdConfigurations = ExtraCareService;
    } else {
      // Todo: Add other services above as else if clauses...
      componentData.component = PdpSafeguardService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'servicesSafeguardPDPContent');
      componentData.lmdConfigurations = null; // to avoid rendering it
    }

    return componentData;
  }
  function getLabelDataByCode(servicesBlocks, code) {
    return servicesBlocks?.find(x => x.code === code);
  }
</script>

{#if eligibleVasEntries?.length > 0}
  <PdpSectionCard titleKey="extra.pdp.service" icon="icon-settings" {appleCareTitleDetails}>
    <section class="service-list">
      {#each eligibleVasEntries as vasEntry}
        {@const { component, labelData, componentData, lmdConfigurations } = getComponentData(
          vasEntry,
          data?.servicesBlocks
        )}
        <svelte:component this={component} data={componentData} {labelData} {lmdConfigurations} />
      {/each}
    </section>
  </PdpSectionCard>
{/if}

<style lang="scss">
  .service-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
</style>
